// extracted by mini-css-extract-plugin
export default {"heroImageWrapper":"HeroImage_heroImageWrapper__+HMKq"};